import React from 'react';
import UserHeader from '../components/UserHeader';
import UserFooter from '../components/UserFooter';
import '../styles/WelcomeScreen.css';

const WelcomeScreen = () => {
  return (
    <div className="welcome-screen">
      <UserHeader />

      {/* Hero Section */}
      <section className="welcome-hero">
        <div className="welcome-hero-overlay"></div>
        <div className="welcome-hero-image">
          <img src="/assets/images/welcome-hero.png" alt="Athlete" />
        </div>

        <div className="welcome-hero-content">
          <h1 className="welcome-hero-title">
            Because moments fade.<br />Legacies don't.
          </h1>

          <div className="welcome-hero-buttons">
            <button className="welcome-hero-btn welcome-hero-btn-primary">
              Create your legacy
            </button>
            <button className="welcome-hero-btn welcome-hero-btn-secondary">
              Learn more
            </button>
          </div>
        </div>
      </section>

      <UserFooter />
    </div>
  );
};

export default WelcomeScreen;
